// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"d9221052","61":"70db9126","203":"a0957429","469":"13a191cb","516":"2df40537","987":"aa87c527"}[chunkId] + ".chunk.js";
};